import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BotAuthenticationPage from './BotAuthenticationPage.tsx';
import CreateEditForm from './CreateEditForm.tsx';
import EmbeddedSignup from '../Whatsapp/Manager/EmbeddedSignup.tsx';

const SettingsRoute = () => {
  return (
    <Routes>
      <Route path={'/bot'} element={<BotAuthenticationPage />} />
      <Route path="bot/create" element={<CreateEditForm />} />
      <Route path={'bot/edit/:Id'} element={<CreateEditForm />} />
       <Route path={'/meta-embedded-signup'} element={<EmbeddedSignup />} />
    </Routes>
  );
};
export default SettingsRoute;
